import styled from '@emotion/styled';
import { Box } from '@material-ui/core';

export const StyledTabPanel = styled(Box)`
  padding: ${({ theme }) => theme.spacing(1)}px;
  margin-bottom: ${({ theme }) => theme.spacing(1)}px;
  height: 300px;
  overflow: hidden;
`;
